'use strict';

var createStyles$1 = require('../../../styles/esm/createStyles/createStyles.js');

// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return createStyles$1(styles);
}

module.exports = createStyles;
